@if (dataSource.data.length) {
  <ng-content></ng-content>
  <mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="ledgerCode">
      <mat-header-cell *matHeaderCellDef> Ledger Code </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.ledgerCode?.code }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="fee">
      <mat-header-cell *matHeaderCellDef> Adjustments </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <b
          >{{ element.actionType == 'Subtract' ? '- $' : '+ $'
          }}{{ element.fee }}</b
        >
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="description">
      <mat-header-cell *matHeaderCellDef>
        Line Item Description
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.description }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="starts">
      <mat-header-cell *matHeaderCellDef> Starts </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.starts | feeAdjustmentCondition }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="ends">
      <mat-header-cell *matHeaderCellDef> Ends </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.ends | feeAdjustmentCondition }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="links">
      <mat-header-cell
        class="report-icon-links"
        *matHeaderCellDef
      ></mat-header-cell>
      <mat-cell
        class="report-icon-links"
        *matCellDef="let element; let i = index"
      >
        <button
          type="button"
          mat-icon-button
          aria-label="Fee adjustment actions"
          [matMenuTriggerFor]="menu"
        >
          <mat-icon>more_vert</mat-icon>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="onEditFeeAdjustment(i)">
              Edit Fee Adjustment
            </button>
            <button mat-menu-item (click)="onDeleteFeeAdjustment(i)">
              Delete Fee Adjustment
            </button>
          </mat-menu>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row
      *matHeaderRowDef="displayedColumns; sticky: true"
    ></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
}
